<script>
  /**
   * Los avisos de la app.
   *
   * Se muestran arriba de la lista, máximo tres, y cada uno se puede cerrar.
   * Cerrarlo no lo silencia para siempre: vuelve a los tres días si la
   * situación sigue igual. Silenciar para siempre haría que un aviso
   * importante desapareciera por un descarte de hace meses.
   */
  import { GRAVEDAD } from '../lib/coaching.js';

  let { avisos = [], alDescartar = () => {} } = $props();

  const CLASES = {
    [GRAVEDAD.URGENTE]: 'urgente',
    [GRAVEDAD.ATENCION]: 'atencion',
    [GRAVEDAD.INFORMATIVO]: 'info',
    [GRAVEDAD.CELEBRACION]: 'bueno',
  };
</script>

{#if avisos.length}
  <div class="avisos">
    {#each avisos as a (a.id)}
      <article class="aviso {CLASES[a.gravedad]}">
        <div class="cuerpo">
          <p class="titulo">{a.titulo}</p>
          <p class="texto">{a.texto}</p>
          {#if a.accion}
            <p class="accion">{a.accion}</p>
          {/if}
        </div>
        <button class="cerrar" onclick={() => alDescartar(a.id)} aria-label="Cerrar aviso">×</button>
      </article>
    {/each}
  </div>
{/if}

<style>
  .avisos {
    display: flex;
    flex-direction: column;
    gap: var(--e-2);
    padding: 0 var(--gutter) var(--e-4);
  }

  .aviso {
    display: flex;
    gap: var(--e-2);
    align-items: flex-start;
    padding: var(--e-3);
    border-radius: var(--r-lg);
    /* La franja de color a la izquierda es lo que diferencia la gravedad sin
       pintar todo el bloque. Un aviso entero de color rojo da ansiedad y se
       cierra sin leer. */
    border-left: 3px solid;
    background: var(--bg-surface);
    border-top: 1px solid var(--border);
    border-right: 1px solid var(--border);
    border-bottom: 1px solid var(--border);
    animation: aparecer var(--d-normal) var(--ease-entrada) backwards;
  }
  @keyframes aparecer {
    from { opacity: 0; transform: translateY(-6px) }
    to   { opacity: 1; transform: translateY(0) }
  }

  .aviso.urgente  { border-left-color: var(--peligro);  background: var(--peligro-suave) }
  .aviso.atencion { border-left-color: var(--alerta);   background: var(--alerta-suave) }
  .aviso.info     { border-left-color: var(--ink-3) }
  .aviso.bueno    { border-left-color: var(--ingreso);  background: var(--ingreso-suave) }

  .cuerpo { flex: 1; min-width: 0; display: flex; flex-direction: column; gap: 2px }

  .titulo {
    font-size: var(--t-sm);
    font-weight: var(--w-semibold);
    color: var(--ink-1);
  }
  .texto {
    font-size: var(--t-sm);
    color: var(--ink-2);
    line-height: var(--lh-normal);
  }
  /* La acción va en otro tono: es lo que se puede hacer, no lo que pasó. */
  .accion {
    font-size: var(--t-xs);
    color: var(--ink-3);
    line-height: var(--lh-normal);
    margin-top: 2px;
  }

  .cerrar {
    width: 28px;
    height: 28px;
    flex: 0 0 auto;
    display: grid;
    place-items: center;
    font-size: var(--t-lg);
    color: var(--ink-3);
    border-radius: var(--r-full);
    opacity: 0.6;
  }
  .cerrar:active { opacity: 1 }
</style>
